import React from 'react';
import './FullScreenBgVideo.css';


function FullScreenBgVideo(props) {
    const makeMuted = (elt) => {
        if (elt) {
            elt.muted = true;
        }
    };
    return (
        <section className="fullScreenVideoSection">
            <video className="fullScreenVideo" playsInline loop autoPlay ref={makeMuted} muted rel={"preload"}>
                <source src={props.desktopUrl} type={'video/mp4'}></source>
            </video>
            <video className="fullScreenVideoMobile" playsInline loop autoPlay ref={makeMuted} muted rel={"preload"}>
                <source src={props.mobileUrl}></source>
            </video>
        </section>
    );
}

export default FullScreenBgVideo;